import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import getNavigationText from 'selectors/getNavigationText';
import { getLanguage } from 'selectors/getMatch';
import icons from 'config/icons';
import Link from 'components/link';
import I18n from 'components/i18n';
import { ToggleContainerConsumer } from 'context/toggleContainer';

import styles from './navExplore.css';

const renderExploreLinks = (
  linkList,
  urlPrefix,
  langCode,
  closeContainer,
  isDesktopHeaderNav,
  hideLanguagesMenu,
) => (
  linkList.map((exploreLink) => (
    <li
      className={classNames(
        styles.exploreLink,
        styles[urlPrefix],
        { [styles.isDesktopHeaderNav]: isDesktopHeaderNav },
      )}
      key={exploreLink.label}
    >
      <Link
        to={`/${langCode}/magazine/${'See All' === exploreLink.label ? 'category' : urlPrefix}${exploreLink.url}/`}
        onClick={isDesktopHeaderNav ? hideLanguagesMenu : closeContainer}
      >
        {exploreLink.label}
      </Link>
    </li>
  ))
);

class NavExplore extends Component {
  state = {
    isVisible: false,
  };

  hideLanguagesMenu = () => {
    this.setState({ isVisible: false });
  };

  toggleIsVisible = () => {
    this.setState({ isVisible: !this.state.isVisible });
  };

  // react-onclickoutside requires this method be defined
  handleClickOutside = () => {
    this.hideLanguagesMenu();
  };

  render() {
    const { isDesktopHeaderNav, navigationTextObj, language } = this.props;

    return (
      <ToggleContainerConsumer>
        {({ close: closeContainer }) => (
          <div className={styles.navExploreWrapper}>
            {navigationTextObj.categories &&
            navigationTextObj.categories.length ?
              <ul className={isDesktopHeaderNav ?
                styles.categoriesContainer
                : styles.sectionContainer}
              >
                {!isDesktopHeaderNav &&
                  <h3 className={styles.sectionLabel}>
                    <I18n
                      field="categories"
                      defaultText="Explore"
                    />
                  </h3>
                }
                {renderExploreLinks(
                  navigationTextObj.categories,
                  'category',
                  language,
                  closeContainer,
                  isDesktopHeaderNav,
                )}
              </ul> :
              null
            }
            {navigationTextObj.aboutLanguages &&
            navigationTextObj.aboutLanguages.length ?
              <div className={isDesktopHeaderNav ?
                styles.languagesContainer
                : styles.sectionContainer}
              >
                {isDesktopHeaderNav ?
                  <button
                    className={styles.toggle}
                    onClick={this.toggleIsVisible}
                  >
                    <I18n
                      field="languages"
                      defaultText="Languages"
                    />
                    <img
                      alt="Expand Language Categories"
                      src={icons.downArrow}
                      height="4"
                      width="8"
                    />
                  </button>
                  :
                  <h3 className={styles.sectionLabel}>
                    <I18n
                      field="articles-about"
                      defaultText="Articles About"
                    />
                  </h3>
                }
                <ul className={classNames(
                  styles.exploreLinksContainer,
                  { [styles.isVisible]: this.state.isVisible })}
                >
                  {renderExploreLinks(
                    navigationTextObj.aboutLanguages,
                    'tags',
                    language,
                    closeContainer,
                    isDesktopHeaderNav,
                    this.hideLanguagesMenu,
                  )}
                </ul>
              </div> :
              null
            }
          </div>
        )}
      </ToggleContainerConsumer>
    );
  }
}

NavExplore.propTypes = {
  isDesktopHeaderNav: PropTypes.bool,
  language: PropTypes.string.isRequired,
  navigationTextObj: PropTypes.object.isRequired,
};

NavExplore.defaultProps = {
  isDesktopHeaderNav: false,
};

const mapStateToProps = (state) => ({
  navigationTextObj: getNavigationText(state),
  language: getLanguage(state),
});

const withRedux = connect(
  mapStateToProps,
);

const wrapWithStyles = withStyles(styles);

export default withRedux(wrapWithStyles(onClickOutside(NavExplore)));
